import { useEffect, useState } from "react";
import { useDoctorContext } from "../context/DoctorContext";
import PatientsList from "./ui/PatientsList";
import Loader from "./Loader";
import "./PatientSharing.css"; // basic styles for modal
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";

const PatientSharing = ({ docId }) => {
  const {
    filterPatients,
    dashboardLoading,
    doctorsList,
    setDoctorsList,
    sharedPatientsList,
    setSharedPatientsList,
  } = useDoctorContext();
  const [searchTerm, setSearchTerm] = useState("");
  const [docSearchTerm, setDocSearchTerm] = useState("");
  const [patientId, setPatientId] = useState(null);
  const [openDoctorslist, setOpenDoctorslist] = useState(false);
  const [loading, setLoading] = useState(false);
  const [sharedLoading, setSharedLoading] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [mergedList, setMergedList] = useState([]);
  const [docPatientRemoving, setDocPatientRemoving] = useState("");
  const BackendUrl = process.env.REACT_APP_BACKEND_URL;
  const navigate = useNavigate();

  const handleOpenDoctorslist = (patient) => {
    setPatientId(patient?.patient_id);
    setOpenDoctorslist(true);
  };

  const handleCloseModal = () => {
    setOpenDoctorslist(false);
    setPatientId(null);
    setDocSearchTerm("");
  };

  async function fetchDoctorsList() {
    try {
      setLoading(true);
      const token = localStorage.getItem("s2stoken");
      const { data } = await axios.get(`${BackendUrl}/api/get_pediatricians`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        withCredentials: true,
      });
      console.log(data, "doctors list");
      setDoctorsList(data.data || []);
    } catch (error) {
      toast.error("Error fetching doctors list");
      console.error("Error fetching doctors list:", error);
      if (error?.response?.data?.message === "Token has expired") {
        localStorage.removeItem("s2stoken");
        navigate("/");
      }
    } finally {
      setLoading(false);
    }
  }
  async function getSharedPatientsList() {
    try {
      setSharedLoading(true);
      const token = localStorage.getItem("s2stoken");
      const { data } = await axios.get(
        `${BackendUrl}/api/get_patient_access_by_primary_doctor/${docId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          withCredentials: true,
        }
      );
      console.log(data, "doctors list");
      setSharedPatientsList(data.data || []);
    } catch (error) {
      toast.error("Error fetching shared aptients list");
      console.error("Error fetching doctors list:", error);
      if (error?.response?.data?.message === "Token has expired") {
        localStorage.removeItem("s2stoken");
        navigate("/");
      }
    } finally {
      setSharedLoading(false);
    }
  }

  const handleShare = async (specialist_id) => {
    try {
      const token = localStorage.getItem("s2stoken");
      setSubmitting(true);
      const { data } = await axios.post(
        `${BackendUrl}/api/share_patient_access`,
        {
          patient_id: patientId,
          primary_doctor_id: docId,
          specialist_id,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          withCredentials: true,
        }
      );
      if (data?.success) {
        toast.success("Access granted successfully");
        getSharedPatientsList();
      }
    } catch (error) {
      toast.error("Error fetching doctors list");
      console.error("Error fetching doctors list:", error);
      if (error?.response?.data?.message === "Token has expired") {
        localStorage.removeItem("s2stoken");
        navigate("/");
      }
    } finally {
      setSubmitting(false);
      handleCloseModal();
    }
  };

  const handleRemoveAccess = async (specialist_id, patient_id) => {
    try {
      const token = localStorage.getItem("s2stoken");
      setDocPatientRemoving(`${specialist_id}-${patient_id}`);
      const { data } = await axios.post(
        `${BackendUrl}/api/revoke_patient_access`,
        {
          patient_id,
          primary_doctor_id: docId,
          specialist_id,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          withCredentials: true,
        }
      );
      if (data.success) {
        getSharedPatientsList();
        toast.success("Access removed successfully");
      }
    } catch (error) {
      toast.error("Error removing access");
      if (error?.response?.data?.message === "Token has expired") {
        localStorage.removeItem("s2stoken");
        navigate("/");
      }
      console.error("Error removing access:", error);
      } finally {
      setDocPatientRemoving("");
    }
  }

    useEffect(() => {
    const loadData = async () => {
        await Promise.all([
        doctorsList.length === 0 && fetchDoctorsList(),
        sharedPatientsList.length === 0 && getSharedPatientsList(),
        ]);
    };
    loadData();
    }, []);

    
    // Merge efficiently
    useEffect(() => {
      if (!sharedLoading) {

        if (!filterPatients.length || !doctorsList.length) {
          setMergedList([]);
          return;
        }
        // Create lookup maps
        const patientMap = Object.fromEntries(filterPatients.map(p => [p.patient_id, p]));
        const doctorMap = Object.fromEntries(doctorsList.map(d => [d.pediatrician_id, d]));
        const mergedArray = sharedPatientsList.map(shared => {

            const patient = patientMap[shared.patient_id] || {};
            const doctor = doctorMap[shared.specialist_id] || {};
    
            return {
                patient_first_name: patient.first_name || "",
                patient_last_name: patient.last_name || "",
                patient_id: patient.patient_id || "",
                specialist_first_name: doctor.pediatrician_first_name || "",
                specialist_last_name: doctor.pediatrician_last_name || "",
                specialist_id: doctor.pediatrician_id
            };
        });
        setMergedList(mergedArray);
      }
    }, [sharedPatientsList, filterPatients, doctorsList]);

    // console.log(sharedPatientsList, "sharedPatientsList");
    // console.log(filterPatients, "patientsList");
    // console.log(doctorsList, "doctorsList");
    // console.log(mergedList, "mergedList");
  return (
    <div className="doc-dashboard" style={{ fontFamily: "Poppins" }}>
      <Loader isLoading={dashboardLoading} />
      <div className="doc-dashboardContainer">
        <PatientsList
          filterPatients={filterPatients}
          action={handleOpenDoctorslist}
          searchTerm={searchTerm}
          setSearchTerm={setSearchTerm}
          actionLabel="Share"
        />
        <div className="shared-patients-section">
          <h3>Shared Patients List</h3>
          {sharedLoading ? (
            <div className="loading-doctors-list">
              <FontAwesomeIcon icon={faSpinner} spin size="lg" />
              <p>Loading shared patients list...</p>
            </div>
          ) : mergedList.length === 0 ? (
            <p>No shared patients available.</p>
          ) : (
            <div className="shared-patients-list">
              <div className="shared-patient-header">
                <p>Patient</p>
                <p>Shared With</p>
                <p>Action</p>
              </div>
              {mergedList.map((item, index) => (
                <div key={`${item.patient_id}-${item.specialist_id}-${index}`} className="shared-patient-item">
                  <p translate="no">{item.patient_first_name} {item.patient_last_name}</p>
                  <p translate="no">{item.specialist_first_name} {item.specialist_last_name}</p>
                  <button disabled={docPatientRemoving} onClick={()=>handleRemoveAccess(item.specialist_id,item.patient_id)}>{docPatientRemoving === `${item.specialist_id}-${item.patient_id}` ? "Removing..." : "Remove Access"}</button>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>

      {openDoctorslist && (
        <div className="sharing-modal-overlay" onClick={handleCloseModal}>
          <div
            className="sharing-modal-content"
            onClick={(e) => e.stopPropagation()} // prevent closing when clicking inside modal
          >
            {loading || submitting ? (
              <div
                className={`loading-doctors-list ${
                  submitting ? "share-submitting" : ""
                }`}
              >
                <FontAwesomeIcon icon={faSpinner} spin size="lg" />
                <p>
                  {submitting
                    ? "Processing..."
                    : "Please wait, loading pediatricians list..."}
                </p>
              </div>
            ) : (
              <>
                <h2>Pediatricians List</h2>
                <div className="doctors-list-container">
                  {/* <p>Search By First name</p> */}
                  <input
                    type="text"
                    placeholder="Search by Provider ID"
                    value={docSearchTerm}
                    onChange={(e) => setDocSearchTerm(e.target.value)}
                    className="doc-patient-search-input share-sticky-input"
                  />
                  {doctorsList.length === 0 ? (
                    <p>No pediatricians available.</p>
                  ) : (
                    doctorsList
                      .filter((doct) =>doct.pediatrician_id !== docId)
                      .filter((doct) =>
                        doct.pediatrician_id.toString()
                          .includes(docSearchTerm.toString())
                      )
                      .map((doc) => (
                        <div
                          key={doc.pediatrician_id}
                          className={`doctor-item`}
                        >
                          <div>
                            {/* <p>Name: <span translate="no">{doc.pediatrician_first_name} {doc.pediatrician_last_name}</span></p>
                            <p translate="no">Clinic: {doc.pediatrician_clinic_name}</p> */}
                            <p translate="no">Id: <span>{doc.pediatrician_id.toString()}</span></p>
                          </div>
                          <button
                            onClick={() => handleShare(doc.pediatrician_id)}
                          >
                            Give access
                          </button>
                        </div>
                      ))
                  )}
                </div>
                <div className="sharing-modal-actions">
                  <button
                    onClick={handleCloseModal}
                    className="sharing-cancel-btn"
                  >
                    Cancel
                  </button>
                </div>
              </>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default PatientSharing;
